/**
 * Filter utilities for dispatch/call display in the driver app.
 * ACCEPTED_AWAITING is not actionable by drivers (company accepted offer, awaiting dispatch).
 */

/** Statuses that should never be displayed in the driver app */
const HIDDEN_AWAITING_STATUSES = [
  'ACCEPTED_AWAITING', // Company accepted offer, awaiting dispatch (not actionable by drivers)
] as const;

/**
 * Returns true if the dispatch/call should be hidden from the driver app.
 * Filters out ACCEPTED_AWAITING (not actionable by drivers).
 */
export function shouldHideDispatch(status: string | undefined | null): boolean {
  if (!status) return false;
  const s = String(status).toUpperCase();
  return HIDDEN_AWAITING_STATUSES.some((hidden) => s === hidden);
}

/**
 * Filters an array of dispatches/calls to exclude ACCEPTED_AWAITING.
 */
export function filterVisibleDispatches<T extends { status?: string | null }>(
  items: T[]
): T[] {
  return items.filter((item) => !shouldHideDispatch(item?.status));
}

export function isCanceledDispatchStatus(status: string | undefined | null): boolean {
  if (!status) return false;
  const s = String(status).toUpperCase();
  return s === 'CANCELED';
}

/**
 * Dispatch / home "Calls" lists hide canceled jobs; Dispatch tab keeps them for visibility.
 */
export function filterCanceledDispatchesForCallsViews<T extends { status?: string | null }>(
  items: T[],
  hideCanceled: boolean
): T[] {
  if (!hideCanceled) return items;
  return items.filter((item) => !isCanceledDispatchStatus(item?.status));
}
